import api from './api'

export const dashboardService = {
  /**
   * Obtiene estadísticas generales del sistema (para ADMIN, SUPERADMIN, VETERINARIO)
   */
  async getStats(params = {}) {
    const response = await api.get('/dashboard/stats', { params })
    // Laravel devuelve { success: true, data: { ... } }
    return response.data
  },

  /**
   * Obtiene estadísticas específicas para usuarios DUEÑO
   * Solo muestra datos relacionados con sus mascotas
   */
  async getStatsDueno() {
    const response = await api.get('/dashboard/stats/dueno')
    return response.data
  },

  /**
   * Obtiene estadísticas específicas para usuarios PET_SITTER
   * Solo muestra datos relacionados con las mascotas que cuida
   */
  async getStatsPetSitter() {
    const response = await api.get('/dashboard/stats/pet-sitter')
    return response.data
  },

  /**
   * Obtiene estadísticas específicas para usuarios VETERINARIO
   * Solo muestra datos relacionados con su clínica y su trabajo
   */
  async getStatsVeterinario() {
    const response = await api.get('/dashboard/stats/veterinario')
    return response.data
  },
}

